/**
 * Preview / generated PDF body styling.
 * Saved with the report into report_pdf_settings.settings.
 * Empty / missing JSON keeps these defaults so live reports do not change.
 */

export const DEFAULT_PDF_SETTINGS = {
	sectionSeparators: true,
	fieldLines: true,
	sectionFontSize: 16,
	fieldNameFontSize: 12,
	fieldDataFontSize: 12,
	sectionSpace: 10,
	fieldSpace: 5,
	nameGap: 10,
	pageMargin: 10,
	lineHeight: 1.2,
	/** Don't start a section/field when less than this % of the page remains. 0 = off. */
	newContentThreshold: 0,
};

const clampNumber = (next, min, max, step, fallback) => {
	const value = Number(next);
	if (!Number.isFinite(value)) return fallback;
	const snapped = Math.round(value / step) * step;
	const rounded = step < 1 ? Number(snapped.toFixed(2)) : Math.round(snapped);
	return Math.min(max, Math.max(min, rounded));
};

/** Merge saved JSON with defaults and clamp ranges used by the preview controls. */
export const normalizePdfSettings = (raw) => {
	const src = raw && typeof raw === "object" && !Array.isArray(raw) ? raw : {};
	return {
		sectionSeparators: src.sectionSeparators !== false,
		fieldLines: src.fieldLines !== false,
		sectionFontSize: clampNumber(src.sectionFontSize, 8, 72, 1, DEFAULT_PDF_SETTINGS.sectionFontSize),
		fieldNameFontSize: clampNumber(src.fieldNameFontSize, 8, 72, 1, DEFAULT_PDF_SETTINGS.fieldNameFontSize),
		fieldDataFontSize: clampNumber(src.fieldDataFontSize, 8, 72, 1, DEFAULT_PDF_SETTINGS.fieldDataFontSize),
		sectionSpace: clampNumber(src.sectionSpace, 0, 48, 1, DEFAULT_PDF_SETTINGS.sectionSpace),
		fieldSpace: clampNumber(src.fieldSpace, 0, 48, 1, DEFAULT_PDF_SETTINGS.fieldSpace),
		nameGap: clampNumber(src.nameGap, 0, 48, 1, DEFAULT_PDF_SETTINGS.nameGap),
		pageMargin: clampNumber(src.pageMargin, 0, 48, 1, DEFAULT_PDF_SETTINGS.pageMargin),
		lineHeight: clampNumber(src.lineHeight, 1, 2, 0.1, DEFAULT_PDF_SETTINGS.lineHeight),
		newContentThreshold: clampNumber(src.newContentThreshold, 0, 50, 1, DEFAULT_PDF_SETTINGS.newContentThreshold),
	};
};

export const ensurePdfSettings = (payload = {}) => ({
	...payload,
	pdfSettings: normalizePdfSettings(payload.pdfSettings),
});
